import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const EMAIL_RE = /([\w.+-]+@[\w-]+\.[\w.]+\w)/g;
const linkify = (text) => text.split(EMAIL_RE).map((part, i) => (i % 2
  ? <a key={i} href={`mailto:${part}`} className="legal-mail" data-testid="legal-email-link">{part}</a>
  : part));

export const LegalPage = ({ testId, label, title, effective, sections }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — Iron Gate Consulting`;
    return () => { document.title = "Pay It Forward — Iron Gate Consulting"; };
  }, [title]);

  return (
    <main className="page-body legal-body" data-testid={testId}>
      <motion.article className="card legal-card" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}>
        <Link to="/" className="legal-back" data-testid="legal-back-link">← Back to Pay It Forward</Link>
        <div className="section-label">{label}</div>
        <h1 className="legal-title">{title}</h1>
        <p className="legal-effective">Effective {effective}</p>
        {sections.map(([h, paras]) => (
          <section key={h} className="legal-section">
            <h2>{h}</h2>
            {paras.map((p, i) => (Array.isArray(p)
              ? <ul key={i}>{p.map((li) => <li key={li}>{linkify(li)}</li>)}</ul>
              : <p key={i}>{linkify(p)}</p>))}
          </section>
        ))}
      </motion.article>
    </main>
  );
};
